<!-- 
	EditNews
	props: User
  	role: Admin
	Called by @/views/AdminEditNews to edit previously created news items for user display
  	Date function allows for future deployment of the message on the front end as well as removal after specified date
-->

<template>
	<div class="create-news">
		<div class="text-3xl">Edit News Item</div>
		<div v-if="error" class="alert -mt-4">
			<Alert>{{ error }}</Alert>
		</div>
		<form class="text-black" @submit.prevent="editNews">
			<div class="form-group">
				<input
					:value="newsItem.title"
					@input="newsItem.title = $event.target.value"
					class="w-1/2"
					type="text"
					placeholder="Title"
					required
				/>
			</div>
			<div class="form-group">
				<textarea
					:value="newsItem.content"
					@input="newsItem.content = $event.target.value"
					class="w-1/2"
					placeholder="Content"
					rows="10"
					required
				/>
			</div>
			<div class="form-group">
				<input
					:value="newsItem.hyperlink"
					@input="newsItem.hyperlink = $event.target.value"
					class="w-1/2"
					type="url"
					placeholder="Hyperlink"
				/>
			</div>
			<div class="form-group">
				<input
					:value="newsItem.hyperlinkText"
					@input="newsItem.hyperlinkText = $event.target.value"
					class="w-1/2"
					type="text"
					placeholder="Hyperlink Button Text"
				/>
			</div>
			<div class="form-group">
				<label for="publishDate" class="text-white">Publish Date</label>
				<br />
				<input
					:value="newsItem.publishDate"
					@input="newsItem.publishDate = $event.target.value"
					type="date"
					name="publishDate"
					id="date"
					required
				/>
			</div>
			<div class="form-group">
				<label for="removalDate" class="text-white">Removal Date</label>
				<br />
				<input
					:value="newsItem.removalDate"
					@input="newsItem.removalDate = $event.target.value"
					type="date"
					name="removalDate"
					id="date"
				/>
			</div>
			<CustomButton>Edit News Item</CustomButton>
		</form>
	</div>
</template>
<script>
	import firebase from "firebase";
	import { useRoute } from "vue-router";

	import Alert from "@/components/Alert";
	import CustomButton from "@/components/CustomButton";

	export default {
		name: "EditNews",
		props: ["user"],
		components: {
			CustomButton,
			Alert,
		},
		data() {
			return {
				newsItem: {
					title: "",
					content: "",
					hyperlink: "",
					hyperlinkText: "",
					publishDate: "",
					removalDate: "",
					createdAt: "",
					author: "",
					id: "",
				},
				error: null,
			};
		},
		created() {
			// get the specific news item based off newsId passed by params
			const route = useRoute();
			const newsId = route.params.News_Id;

			const db = firebase
				.firestore()
				.collection("news")
				.doc(newsId);

			db.get().then((doc) => {
				if (doc.exists) {
					this.newsItem.title = doc.data().title;
					this.newsItem.content = doc.data().content;
					this.newsItem.hyperlink = doc.data().hyperlink;
					this.newsItem.hyperlinkText = doc.data().hyperlinkText;
					this.newsItem.publishDate = doc.data().publishDate;
					this.newsItem.removalDate = doc.data().removalDate;
					this.newsItem.createdAt = doc.data().createdAt;
					this.newsItem.author = doc.data().author;
					this.newsItem.id = doc.id;
				} else {
					this.error = "Document does not exist";
				}
			});
		},
		methods: {
			editNews() {
				// edit the news item on admin action
				const editedAt = new Date();

				const db = firebase.firestore();

				const docId = this.newsItem.id;

				const newsData = {
					title: this.newsItem.title,
					content: this.newsItem.content,
					hyperlink: this.newsItem.hyperlink,
					hyperlinkText: this.newsItem.hyperlinkText,
					publishDate: this.newsItem.publishDate,
					removalDate: this.newsItem.removalDate,
					author: this.newsItem.author,
					editor: this.user.data.email,
					createdAt: this.newsItem.createdAt,
					editedAt: editedAt,
				};

				db.collection("news")
					.doc(docId)
					.update(newsData);

				alert(`${this.newsItem.title} has been edited.`);
			},
		},
	};
</script>

<style scoped>
	.form-group {
		margin: 25px 0;
	}

	form .form-group input {
		border-bottom: 1px solid #ffffff;
		padding: 5px;
		background-color: transparent;
		color: #ffffff;
	}

	form .form-group textarea {
		border: 1px solid #ffffff;
		padding: 5px;
		background-color: transparent;
		color: #ffffff;
	}

	form .form-group #date {
		width: 170px;
	}

	form .form-group ::-webkit-calendar-picker-indicator {
		filter: invert(1);
	}
</style>
